// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  font-size: 14px;
}

:host {
  background: var(--ion-white-tertiary) !important;
  --background: var(--ion-white-tertiary) !important;
}

ion-header ion-toolbar {
  background: var(--ion-white-tertiary) !important;
}

ion-card.contentcard {
  min-height: 50vh;
  background: var(--ion-white-tertiary) !important;
  --background: var(--ion-white-tertiary) !important;
}
ion-card.contentcard ion-card {
  box-shadow: none;
  text-align: center;
}
ion-card.contentcard ion-card ion-icon[name=alert-circle-outline] {
  font-size: 5em;
}
ion-card.contentcard ion-list .selected-food {
  width: 85vw;
  height: 25vw;
  background: var(--ion-ultra-primary);
  padding: 0vw;
  margin: 0 auto;
  position: relative;
  transition: all 0.5s ease-in-out;
  overflow: hidden;
  display: flex;
  contain: none;
  box-shadow: var(--shadow-m);
  border-radius: 10px;
  margin-top: 3vw;
}
ion-card.contentcard ion-list .selected-food .innercard {
  width: 85vw;
  height: 25vw;
  background: transparent;
  position: relative;
  transition: all 0.3s ease-in-out;
  overflow: visible;
  contain: none;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
ion-card.contentcard ion-list .selected-food .innercard .action-slot {
  position: absolute;
  left: 2vw;
  top: 2vw;
  overflow: visible;
  contain: none;
  z-index: 5;
  transition: all 0.3s ease-in-out;
  transform: scaleY(1);
}
ion-card.contentcard ion-list .selected-food .innercard .action-slot ion-chip.mainchip {
  background: var(--ion-more-primary);
  margin: 0;
  padding: 0vw 2vw;
  min-height: 3vw;
  backdrop-filter: blur(10px);
}
ion-card.contentcard ion-list .selected-food .innercard .action-slot ion-note {
  font-size: 12px;
  color: var(--ion-text-primary);
}
ion-card.contentcard ion-list .selected-food .innercard .imgcontainer {
  position: relative;
  width: 25vw;
  height: 25vw;
  aspect-ratio: 1;
  top: 0vw;
  left: 0vw;
  border-radius: 0px;
  z-index: 3;
  overflow: visible;
  contain: none;
  transition: all 0.3s ease-in-out, z-index 0.4s ease-in-out 0.4s;
  transform: scale(1) translate3d(0px, 0px, 0px);
}
ion-card.contentcard ion-list .selected-food .innercard .imgcontainer .imgwrapper {
  object-fit: cover;
  width: 100%;
  height: 100%;
  transform: scale(1);
  object-position: 0px 20vw;
  transition: all 0.3s ease-in-out 0.3s;
}
ion-card.contentcard ion-list .selected-food .innercard .imgcontainer .imgwrapper .menu-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 0px 0px;
  transform-origin: 45% 20%;
  transition: all 0.3s ease-in-out 0.5s;
  transform: scale(1);
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut {
  position: relative;
  display: flex;
  height: 25vw;
  width: 60vw;
  border-radius: 0;
  z-index: 2;
  overflow: visible;
  flex-direction: row-reverse;
  justify-content: flex-end;
  top: 0vw;
  gap: 0vw;
  align-items: center;
  transition: all 0.3scubic-bezier 0.645, 0.045, 0.355, 1 0.3s;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom {
  position: relative;
  display: flex;
  height: 25vw;
  min-width: 50vw;
  border-radius: 0;
  z-index: 2;
  overflow: visible;
  flex-direction: column;
  justify-content: center;
  top: 0vw;
  gap: 0vw;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) 0.3s;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .content {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 0vw;
  padding: 2vw;
  transition: all 0.3scubic-bezier 0.645, 0.045, 0.355, 1;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .content .menuname {
  display: block;
  font-size: 12px;
  width: 80%;
  overflow: auto;
  color: var(--ion-dark-tertiary);
  border-radius: 0px;
  font-weight: 400;
  transition: all 0.3scubic-bezier 0.645, 0.045, 0.355, 1;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 1;
  height: 7vw;
  min-width: 50vw;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist {
  display: flex;
  flex-direction: row;
  transition: all 0.3s var(--ease-elastic-3);
  justify-content: space-evenly;
  z-index: 5;
  height: 6vw;
  gap: 1vw;
  align-items: center;
  width: 50vw;
  border: 0px solid var(--ion-dim-secondary);
  border-radius: 10px;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macro {
  transition: all 0.5s var(--ease-elastic-3);
  will-change: contents;
  display: flex;
  gap: 2px;
  width: 15%;
  align-items: center;
  flex-direction: row;
  border: 0px solid var(--prot) !important;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .kcal {
  width: 25% !important;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .kcal .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .kcal .macroname {
  color: var(--ion-dark-tertiary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macrop .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macrop .macroname {
  color: var(--ion-dark-tertiary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macroc .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macroc .macroname {
  color: var(--ion-dark-tertiary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macrof .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macrof .macroname {
  color: var(--ion-dark-tertiary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macroname {
  opacity: 1;
  font-size: 10px !important;
  position: relative;
  transform: rotateX(0deg) translateX(0px);
  font-weight: 400;
  padding: 0px 1vw 0 0;
  margin: 0;
  transition: all 0.5s var(--ease-elastic-3) 0.3s;
  align-items: center;
  justify-items: center;
  will-change: contents;
  display: flex;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .bottom .macrowrap .macrolist .macroval {
  font-size: 12px !important;
  font-weight: 400;
  margin: 0;
  display: flex;
  height: 100%;
  padding: 0;
  transition: all 0.3s var(--ease-elastic-3) 0.3s;
  border-radius: 0px;
  align-items: center;
  justify-items: center;
  color: var(--ion-dark-tertiary);
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .removeBtn {
  max-height: 7vw;
  max-width: 7vw;
  margin: 0;
  background: hsl(var(--drop-white-primary)/0.7);
  position: relative;
  border: none;
  border-radius: 10px;
  padding: 1vw;
  box-shadow: var(--shadow-l);
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-card.contentcard ion-list .selected-food .innercard .contentOut .removeBtn .modalicon {
  height: 6vw;
  width: 6vw;
  stroke: var(--ion-color-danger);
  fill: none;
  stroke-width: 1px;
}
ion-card.contentcard ion-list .selected-food ion-button {
  height: 100%;
  width: 10vw;
  margin: 0;
  --padding-end: 0;
  --padding-start: 0;
  background: var(--ion-white-primary) !important;
  --background: transparent !important;
  position: relative;
  border: none;
  border-radius: 10px;
  --border-radius: 10px;
  padding: 0vw;
  box-shadow: var(--shadow-13);
}

ion-footer ion-toolbar {
  margin-bottom: 0px;
  background: var(--ion-color-medium) !important;
  --background: var(--ion-color-medium)!important ;
}
ion-footer ion-toolbar ion-button {
  min-height: 40px;
  color: var(--ion-dark-tertiary);
  --color: var(--ion-dark-tertiary);
}

.ratingBox {
  --star-color:var(--ion-dark-tertiary);
  color: var(--ion-dark-tertiary);
  --star-color-filled: var(--ion-color-warning);
  scale: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/calendar/selection/selection.page.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACE,gDAAA;EACA,kDAAA;AACF;;AAEI;EACE,gDAAA;AACN;;AAGA;EACE,gBAAA;EACA,gDAAA;EACA,kDAAA;AAAF;AACI;EACI,gBAAA;EACA,kBAAA;AACR;AACQ;EACI,cAAA;AACZ;AAKE;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AAHJ;AAKA;EAEE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AALF;AAOE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,gCAAA;EACA,oBAAA;AALJ;AAQM;EACF,mCAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AANJ;AASM;EACA,eAAA;EACA,8BAAA;AAPN;AAeA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,+DAAA;EACA,8CAAA;AAbF;AAeA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,qCAAA;AAbF;AAgBC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mBAAA;AAdF;AAoBA;EACE,kBAAA;EACA,aAAA;EAEA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,QAAA;EACA,QAAA;EACA,mBAAA;EACA,4DAAA;AAnBF;AAqBA;EACE,kBAAA;EACA,aAAA;EAEA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,QAAA;EACA,mBAAA;EACA,8DAAA;AApBF;AA0BA;EACE,aAAA;EAEI,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,uDAAA;AAzBN;AA2BA;EACI,cAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AAzBJ;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EAEA,yDAAA;AA9BF;AAiCC;EACC,aAAA;EAEI,mBAAA;EACA,0CAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,0CAAA;EACA,mBAAA;AAhCN;AAmCC;EACC,0CAAA;EACA,qBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;AAjCF;AAoCA;EACE,qBAAA;AAlCF;AAmCE;EAEE,iBAAA;EACJ,kBAAA;AAlCA;AAsCQ;EACE,+BAAA;EACA,uBAAA;AApCV;AA+CQ;EAEE,iBAAA;EACV,kBAAA;AA9CA;AAgDQ;EACE,+BAAA;EACA,uBAAA;AA9CV;AAuDQ;EAEE,iBAAA;EACV,kBAAA;AAtDA;AAyDQ;EACE,+BAAA;EACA,uBAAA;AAvDV;AAgEQ;EAEA,iBAAA;EACR,kBAAA;AA/DA;AAiEQ;EACE,+BAAA;EACA,uBAAA;AA/DV;AAmEM;EACE,UAAA;EACA,0BAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,+CAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;AAjER;AAqEM;EACE,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,+BAAA;AAnER;AA0EA;EACI,eAAA;EACA,cAAA;EACA,SAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EAEA,mBAAA;EACA,uBAAA;AAzEJ;AA0EI;EACJ,WAAA;EACA,UAAA;EACA,+BAAA;EACA,UAAA;EACA,iBAAA;AAxEA;AA8EC;EACG,YAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,+CAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,4BAAA;AA5EJ;;AAoFI;EACI,kBAAA;EACA,8CAAA;EACA,gDAAA;AAjFR;AAmFQ;EACI,gBAAA;EACA,+BAAA;EACA,iCAAA;AAjFZ;;AAsFA;EAEI,qCAAA;EACA,+BAAA;EACA,6CAAA;EACA,UAAA;AApFJ","sourcesContent":["ion-title {\n    font-size: 14px;\n}\n\n:host{\n  background: var(--ion-white-tertiary) !important;\n  --background: var(--ion-white-tertiary) !important;\n}\nion-header{\n    ion-toolbar{\n      background: var(--ion-white-tertiary) !important;\n    }\n}\n\nion-card.contentcard {\n  min-height: 50vh;\n  background: var(--ion-white-tertiary) !important;\n  --background: var(--ion-white-tertiary) !important;\n    ion-card {\n        box-shadow: none;\n        text-align: center;\n\n        ion-icon[name=\"alert-circle-outline\"] {\n            font-size: 5em;\n        }\n    }\n\n    ion-list {\n\n  .selected-food{\n    width: 85vw;\n    height: 25vw;\n    background: var(--ion-ultra-primary);\n    padding: 0vw;\n    margin: 0 auto;\n    position: relative;\n    transition: all 0.5s ease-in-out;\n    overflow: hidden;\n    display: flex;\n    contain: none;\n    box-shadow: var(--shadow-m);\n    border-radius: 10px;\n    margin-top: 3vw;\n\n.innercard {\n  \n  width: 85vw;\n  height: 25vw;\n  background: transparent;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n  overflow: visible;\n  contain: none;\n\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n\n  .action-slot {\n    position: absolute;\n    left: 2vw;\n    top: 2vw;\n    overflow: visible;\n    contain: none;\n    z-index: 5;\n    transition: all 0.3s ease-in-out;\n    transform:scaleY(1);\n     \n     \n      ion-chip.mainchip {\n    background: var(--ion-more-primary);\n    margin: 0;\n    padding: 0vw 2vw;\n    min-height: 3vw;\n    backdrop-filter: blur(10px);\n      }\n\n      ion-note {\n      font-size: 12px;\n      color: var(--ion-text-primary);\n     \n      }\n  \n     \n      }\n  \n     \n.imgcontainer {\n  position: relative;\n  width: 25vw;\n  height: 25vw;\n  aspect-ratio: 1;\n  top: 0vw;\n  left: 0vw;\n  border-radius: 0px;\n  z-index: 3;\n  overflow: visible;\n  contain: none;\n  transition: all 0.3s ease-in-out, z-index 0.4s ease-in-out 0.4s;\n  transform: scale(1) translate3d(0px, 0px, 0px);\n\n.imgwrapper {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  transform: scale(1);\n  object-position: 0px 20vw;\n  transition: all 0.3s ease-in-out 0.3s;\n\n\n .menu-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 0px 0px;\n  transform-origin: 45% 20%;\n  transition: all 0.3s ease-in-out 0.5s;\n  transform: scale(1);\n}\n\n}\n\n}\n.contentOut{\n  position: relative;\n  display: flex\n;\n  height: 25vw;\n  width: 60vw;\n  border-radius: 0;\n  z-index: 2;\n  overflow: visible;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  top: 0vw;\n  gap: 0vw;\n  align-items: center;\n  transition: all 0.3scubic-bezier(0.645, 0.045, 0.355, 1) 0.3s;\n\n.bottom {\n  position: relative;\n  display: flex;\n  // background: var(--ion-color-primary);\n  height: 25vw;\n  min-width: 50vw;\n  border-radius:0;\n  z-index: 2;\n  overflow: visible;\n  flex-direction: column;\n  justify-content: center;\n  top: 0vw;\n  gap: 0vw;\n  align-items: center;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) 0.3s;\n\n\n\n  \n\n.content {\n  display: flex\n  ;\n      align-items: center;\n      flex-direction: row;\n      justify-content: center;\n      width: 100%;\n      gap: 0vw;\n      padding: 2vw;\n      transition: all 0.3scubic-bezier(0.645, 0.045, 0.355, 1);\n\n.menuname {\n    display: block;\n    font-size: 12px;\n    width: 80%;\n    overflow: auto;\n    color: var(--ion-dark-tertiary);\n    border-radius: 0px;\n    font-weight: 400;\n    transition: all 0.3scubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n\n}\n\n.macrowrap{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  opacity: 1;\n  height: 7vw;\n  min-width: 50vw;\n  // background: var(--ion-diffuseLight-tertiary);\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n\n\n .macrolist {\n  display: flex\n  ;\n      flex-direction: row;\n      transition: all 0.3s var(--ease-elastic-3);\n      justify-content: space-evenly;\n      z-index: 5;\n      height: 6vw;\n      gap: 1vw;\n      align-items: center;\n      width: 50vw;\n      border: 0px solid var(--ion-dim-secondary);\n      border-radius: 10px;\n\n\n .macro {\n  transition: all 0.5s var(--ease-elastic-3);\n  will-change: contents;\n  display: flex;\n  gap: 2px;\n  width: 15%;\n  align-items: center;\n  flex-direction: row;\n  border: 0px solid var(--prot) !important;\n\n}\n.kcal{\n  width: 25% !important;\n  .macroval{\n    // border: 1px solid var(--kcal);\n    border-left: none;\nborder-right: none;\n    }\n        \n\n        .macroname{\n          color: var(--ion-dark-tertiary);\n          background: transparent;\n        }\n   \n      }\n  \n      .macrop {\n        \n        // background: linear-gradient(0deg, var(--prot) 0%, var(--prot) 2%, rgba(255, 255, 255, 0) 5%, rgba(255, 255, 255, 0) 100%);\n        // background-position: right 4vw bottom 4vw;\n        // background-size: 200%;\n        // background-repeat: no-repeat;\n        .macroval{\n          // border: 1px solid var(--prot);\n          border-left: none;\nborder-right: none;\n          }\n        .macroname{\n          color: var(--ion-dark-tertiary);\n          background: transparent;\n        }\n      }\n  \n      .macroc {\n        // background: linear-gradient(0deg, var(--carb) 0%, var(--carb) 2%, var(--ion-dark-tertiary)0 5%, var(--ion-dark-tertiary)0 100%);\n        // background-position: right 4vw bottom 4vw;\n        // background-size: 200%;\n        // background-repeat: no-repeat;\n        .macroval{\n          // border: 1px solid var(--carb);\n          border-left: none;\nborder-right: none;\n          }\n\n        .macroname{\n          color: var(--ion-dark-tertiary);\n          background: transparent;\n        }\n      }\n  \n      .macrof {\n        // background: linear-gradient(0deg, var(--fat) 0%, var(--fat) 2%, var(--ion-dark-tertiary)0 5%, var(--ion-dark-tertiary)0 100%);\n        // background-position: right 4vw bottom 4vw;\n        // background-size: 200%;\n        // background-repeat: no-repeat;\n        .macroval{\n        // border: 1px solid var(--fat);\n        border-left: none;\nborder-right: none;\n        }\n        .macroname{\n          color: var(--ion-dark-tertiary);\n          background: transparent;\n        }\n      }\n\n      .macroname {\n        opacity: 1;\n        font-size: 10px !important;\n        position: relative;\n        transform: rotateX(0deg) translateX(0px);\n        font-weight: 400;\n        padding: 0px 1vw 0 0;\n        margin: 0;\n        transition: all 0.5s var(--ease-elastic-3) 0.3s;\n        align-items: center;\n        justify-items: center;\n        will-change: contents;\n        display: flex;\n        // border-right: 2px solid;\n      }\n  \n      .macroval {\n        font-size: 12px !important;\n        font-weight: 400;\n        margin: 0;\n        display: flex;\n        height: 100%;\n        padding: 0;\n        transition: all 0.3s var(--ease-elastic-3) 0.3s;\n        border-radius: 0px;\n        align-items: center;\n        justify-items: center;\n        color: var(--ion-dark-tertiary);\n      }\n  \n    }\n}\n\n}\n.removeBtn{\n    max-height: 7vw;\n    max-width: 7vw;\n    margin: 0;\n    background: hsl(var(--drop-white-primary) / 0.7);\n    position: relative;\n    border: none;\n    border-radius: 10px;\n    padding: 1vw;\n    box-shadow: var(--shadow-l);\n    display: flex\n;\n    align-items: center;\n    justify-content: center;\n    .modalicon{\nheight: 6vw;\nwidth: 6vw;\nstroke: var(--ion-color-danger);\nfill: none;\nstroke-width: 1px;\n}\n}\n}\n }\n\n ion-button{\n    height: 100%;\n    width: 10vw;\n    margin: 0;\n    --padding-end: 0;\n    --padding-start: 0;\n    background: var(--ion-white-primary) !important;\n    --background: transparent !important;\n    position: relative;\n    border: none;\n    border-radius: 10px;\n    --border-radius: 10px;\n    padding: 0vw;\n    box-shadow: var(--shadow-13);\n }\n}\n  \n    }\n}\n\nion-footer {\n    ion-toolbar {\n        margin-bottom: 0px;\n        background: var(--ion-color-medium)!important ;\n        --background: var(--ion-color-medium)!important ;\n\n        ion-button {\n            min-height: 40px;\n            color: var(--ion-dark-tertiary);\n            --color: var(--ion-dark-tertiary);\n        }\n    }\n}\n\n.ratingBox {\n  \n    --star-color:var(--ion-dark-tertiary);\n    color:var(--ion-dark-tertiary);\n    --star-color-filled: var(--ion-color-warning);\n    scale: 0.8;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
